import { useEffect, useState } from "react";
import { fetchClubs } from "@/lib/strapi";

export function useClubs(limit = 24) {
  const [clubs, setClubs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;

    const loadClubs = async () => {
      try {
        setIsLoading(true);
        setError("");
        const data = await fetchClubs({ limit });
        if (mounted) {
          setClubs(data);
        }
      } catch (err) {
        if (mounted) {
          setError(err instanceof Error ? err.message : "Failed to load clubs");
          setClubs([]);
        }
      } finally {
        if (mounted) {
          setIsLoading(false);
        }
      }
    };

    loadClubs();

    return () => {
      mounted = false;
    };
  }, [limit]);

  return { clubs, isLoading, error };
}
